


































































































































































import { Component, Vue, Ref, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { timeout } from '@/utils/common'
import VueSignaturePad from 'vue-signature-pad'
import { IRequestMessage, RequestMessage, Snackbar, Loading } from '@/types/_'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import signalR from '@/signalR/signalR'

Vue.use(VueSignaturePad)

@Component

export default class ViewAssinatura extends Vue {
  $refs!: {
    signaturePad: any,
  }

  penColor: string = 'rgb(51, 0, 133)'
  fc: boolean = false
  fb: boolean = true
  img: string = ''
  dlg: boolean = true
  dial: boolean = false
  loader: boolean = false
  snack: any = { show: false, text: '', icon: '', color: '' }
  files: any[] = []
  errors: any[] = []
  loadingRequest: Loading = {
    status: false,
    text: '',
  }

  get getErrors() {
    return this.errors
  }

  set getErrors(value) {
    this.errors.push(value)
  }

  get getLoadingRequest() {
    return this.loadingRequest
  }

  set getLoadingRequest(value: Loading) {
    this.loadingRequest = value
  }

  get fab() {
    return this.fb
  }

  set fab(value: boolean) {
    this.fb = value
  }

  get fechar() {
    return this.fc
  }

  set fechar(value: boolean) {
    this.fc = value
  }

  get image() {
    return this.image
  }

  set image(value: string) {
    this.img = value
  }

  get dialog() {
    return this.dial
  }

  set dialog(value: boolean) {
    this.dial = value
  }

  get dialog2() {
    return this.dlg
  }

  set dialog2(value: boolean) {
    this.dlg = value
  }

  get loading() {
    return this.loader
  }

  set loading(value: boolean) {
    this.loader = value
  }

  get snackbar() {
    return this.snack
  }

  set snackbar(value: any) {
    this.snack = value
  }

  get getRequestMessage() {
    const requestMessage: IRequestMessage = new RequestMessage()
    return requestMessage
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  setLoadingRequest(status: boolean, text: string) {
    this.getLoadingRequest.status = status
    this.getLoadingRequest.text = text
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

  async inputFile(newFile, oldFile) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    if (newFile.identifier) {
      return
    }

    this.getCadastroMedicoStore.cadastroMedico.assinatura = ''

    const imageBase64: any = await this.toBase64(newFile.file)
    const imageIndex = imageBase64.toString().indexOf(',') + 1
    const imageBase64Result = imageBase64.toString().substr(imageIndex, imageBase64.toString().length - imageIndex)

    const params: any = {
      conviteId: this.$route.params.conviteId,
      // @ts-ignore
      assinatura: imageBase64Result,
    }

    const response = await this.getCadastroMedicoStore.uploadAssinatura(params)

    if (response.success) {
      this.fechar = true
    } else {
      this.snackbar = { show: true, text: 'Ocorreu erro ao enviar arquivo da assinatura.', icon: 'warning', color: '#C62828' }
    }
    this.clearLoadingRequest()
  }

  undo() {
    this.$refs.signaturePad.undoSignature()
  }

  cropSignatureCanvas(canvas) {
    // @ts-ignore
    const croppedCanvas: HTMLCanvasElement = document.createElement('canvas')
    // @ts-ignore
    const croppedCtx: CanvasRenderingContext2D = croppedCanvas.getContext('2d')

    croppedCanvas.width = canvas.width
    croppedCanvas.height = canvas.height
    croppedCtx.drawImage(canvas, 0, 0)

    let w = croppedCanvas.width
    let h = croppedCanvas.height
    const pix = { x: [], y: [] }
    const imageData = croppedCtx.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height)
    let index: number = 0

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        index = (y * w + x) * 4
        if (imageData.data[index + 3] > 0) {
          // @ts-ignore
          pix.x.push(x)
          // @ts-ignore
          pix.y.push(y)
        }
      }
    }

    pix.x.sort((a, b) => a - b)
    pix.y.sort((a, b) => a - b)
    const n = pix.x.length - 1

    w = pix.x[n] - pix.x[0]
    h = pix.y[n] - pix.y[0]
    const cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h)

    croppedCanvas.width = w
    croppedCanvas.height = h
    croppedCtx.putImageData(cut, 0, 0)

    return croppedCanvas.toDataURL()
  }

  async save() {
    const { isEmpty } = this.$refs.signaturePad.saveSignature()
    if (isEmpty) {
      this.snackbar = { show: true, text: 'Nenhuma assinatura foi feita.', icon: 'warning', color: '#C62828' }
    } else {
      this.dialog = true
    }
  }

  async post() {
    this.loading = true
    const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
    // const canvas = document.getElementsByTagName('canvas')[0]
    // const image = this.cropSignatureCanvas(canvas)

    const params: any = {
      conviteId: this.$route.params.conviteId,
      // assinatura: image,
      // assinatura: (image as String).substring(22, image.length),
      assinatura: data.toString().replace('data:image/png;base64,', ''),
    }

    const response = await this.getCadastroMedicoStore.uploadAssinatura(params)
    if (response.success) {
      this.fechar = true
      if (this.$route.params.backpage === 'backpage') {
        // window.history.back()
      }
    } else {
      this.snackbar = { show: true, text: 'Ocorreu erro ao enviar a assinatura.', icon: 'warning', color: '#C62828' }
    }

    this.close()
    this.loading = false
  }

  close() {
    this.dialog = false
  }

  getOutTheWay() {
    window.opener = null
    window.open('', '_self')
    window.close()
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  async mounted() {
    const { conviteId } = this.$route.params
    await signalR.start(conviteId)
  }
}
